module.exports = __webpack_public_path__ + "static/media/review-host.e87802b8.gif";